import { Colors, FInter, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "core";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css } from "styled-components";

export const BookChaptersEmptyContainer = styled(FlexBox)<{ imgShowed?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
    align-items: center;
    justify-content: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
        width: ${LayoutConst.projectCover.m.w}px;
        height: ${(p) => (p.height === p.width) ? LayoutConst.projectCover.m.w : LayoutConst.projectCover.m.h}px;
    }

    @media (max-width: 940px) {
      // width: ${(p) => (p.widthMobile ? p.widthMobile : "auto")};
      // height: ${(p) => (p.heightMobile ? p.heightMobile : "100vh")};
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      // margin-bottom: 24px;
    }


    @media (max-width: 940px) {
        align-items: center;
        justify-content: center;
        font-size: 13px;
    }
`;

export const BookSelectChaptersButton = styled(FInter.Text)`
  font-size: 13px !important;
  line-height: 16px !important;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 400;
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 11px !important; 
      line-height: 13px !important;
  }
`;

export const AddBookChapterButton = styled(FInter.SmallTextMagic)<{ withStroke?: boolean, isEmptyChapters?: boolean }>`
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 10px;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  user-select: none;
  padding: 0 10%;
  font-size: 13px;
  line-height: 16px;

  transition: color 0.2s;

  svg path, svg stroke, svg rect {
    transition: fill 0.2s, stroke 0.2s;
  }

  :hover {
    color: ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
    svg path {
      fill: ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
      ${({ withStroke, theme }) => withStroke ? css`
        stroke:  ${theme.projectEdit.book.chaptersButtons.hover.fill};
      ` : null};
    }
    svg rect {
      stroke:  ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
    }
    transition: color 0.2s, fill 0.2s, stroke 0.2s;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    
    width: ${({isEmptyChapters}) => isEmptyChapters ? '100%' : 'calc(50vw - 20px)'} !important;
    max-width: ${({isEmptyChapters}) => isEmptyChapters ? '100%' : 'calc(50vw - 20px)'} !important;
  }
`;

export const AddBookChapterButtonContainer = styled(ProjectCardContainerNew)<{isEmptyChapters?: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  box-shadow: none;
  z-index: 0;

  @media(max-width: ${LayoutConst.screen.s}px) {  
    flex-direction: column;
    width: 100% !important;
    max-width: 100% !important;
    max-height: calc((50vw - 15px) * 1.407) !important;
    height: calc((50vw - 15px) * 1.407) !important;
    min-height: calc((50vw - 15px) * 1.407) !important;
    margin-bottom: 16px;
  }

  // @media(max-width: 576px) {
  //   width: calc(50vw - 20px) !important;
  //   max-width: calc(50vw - 20px) !important;
  // }
`;

export const BookEmptyAddChapterButton = styled.button`
  display: flex;
  padding: 8px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  background: ${Colors.galBlack100};
  border: none;
  cursor: pointer;

  color: #FFF;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;

  &:disabled {
    background: ${Colors.galBlack21};
    color: ${Colors.galBlack31};
    cursor: not-allowed;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
`import { Colors, FInter, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "core";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css } from "styled-components";

export const BookChaptersEmptyContainer = styled(FlexBox)<{ imgShowed?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
    align-items: center;
    justify-content: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) { 
        width: ${LayoutConst.projectCover.m.w}px;
        height: ${(p) => (p.height === p.width) ? LayoutConst.projectCover.m.w : LayoutConst.projectCover.m.h}px;
    }

    @media (max-width: 940px) {
      // width: ${(p) => (p.widthMobile ? p.widthMobile : "auto")};
      // height: ${(p) => (p.heightMobile ? p.heightMobile : "100vh")};
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      // margin-bottom: 24px;
    }


    @media (max-width: 940px) {
        align-items: center;
        justify-content: center;
        font-size: 13px;
    }
`;

export const BookSelectChaptersButton = styled(FInter.Text)`
  font-size: 13px !important;
  line-height: 16px !important;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 400;
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
      font-size: 11px !important; 
      line-height: 13px !important;
  }
`;

export const AddBookChapterButton = styled(FInter.SmallTextMagic)<{ withStroke?: boolean, isEmptyChapters?: boolean }>`
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 10px;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  user-select: none;
  padding: 0 10%;
  font-size: 13px;
  line-height: 16px;

  transition: color 0.2s;

  svg path, svg stroke, svg rect {
    transition: fill 0.2s, stroke 0.2s;
  }

  :hover {
    color: ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
    svg path {
      fill: ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
      ${({ withStroke, theme }) => withStroke ? css`
        stroke:  ${theme.projectEdit.book.chaptersButtons.hover.fill};
      ` : null};
    }
    svg rect {
      stroke:  ${({ theme }) => theme.projectEdit.book.chaptersButtons.hover.fill};
    }
    transition: color 0.2s, fill 0.2s, stroke 0.2s;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    
    width: ${({isEmptyChapters}) => isEmptyChapters ? '100%' : 'calc(50vw - 20px)'} !important;
    max-width: ${({isEmptyChapters}) => isEmptyChapters ? '100%' : 'calc(50vw - 20px)'} !important;
  }
`;

export const AddBookChapterButtonContainer = styled(ProjectCardContainerNew)<{isEmptyChapters?: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  box-shadow: none;
  z-index: 0;

  @media(max-width: ${LayoutConst.screen.s}px) {  
    flex-direction: column;
    width: 100% !important;
    max-width: 100% !important;
    max-height: calc((50vw - 15px) * 1.407) !important;
    height: calc((50vw - 15px) * 1.407) !important;
    min-height: calc((50vw - 15px) * 1.407) !important;
    margin-bottom: 16px;
  }

  // @media(max-width: 576px) {
  //   width: calc(50vw - 20px) !important;
  //   max-width: calc(50vw - 20px) !important;
  // }
`;

export const BookEmptyAddChapterButton = styled.button`
  display: flex;
  padding: 8px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  background: ${Colors.galBlack100};
  border: none;
  cursor: pointer;

  color: #FFF;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;

  &:disabled {
    background: ${Colors.galBlack21};
    color: ${Colors.galBlack31};
    cursor: not-allowed;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    line-height: 20px;
  }
`